var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapperProps.is,_vm._b({tag:"component"},'component',_vm.wrapperProps,false),[(_vm.isStateColumn)?_c('c-alarm-chip',{attrs:{"value":_vm.item.entity.state}}):_c('span',[_vm._v(_vm._s(_vm._f("get")(_vm.item.entity,_vm.column.value)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }